import {
  CircularProgress,
  createStyles,
  Dialog,
  Divider,
  FormControlLabel,
  IconButton,
  makeStyles,
  Switch,
  Theme,
  Typography,
  Box,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import { useLocation, Redirect, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../reduxhooks";
import { signIn } from '../redux/AccountRedux';
import {
  availableCategories,
  fetchMailingPreference,
  getValidMBSValues,
  MailingCategoryKey,
  MessageBroadcastSettings,
  postMailingPreference,
  setRedirectLink,
} from "../redux/MailingPreferenceRedux";
import { Formik, Form, FieldArray } from "formik";
import * as yup from "yup";
import { FareastButton } from "./OverlayComponentButton";
import { ArrowBack } from "@material-ui/icons";
import { sendWebsiteLivestreamMessage } from "../telegrambotevents";
import { APIRequestStatus } from "common-ts/dist/models/APIRequestStatus";
import { submitCouponRequest } from "../redux/CartRedux";

function PageMailingPreference() {
  // Routing
  let { promoUniqueId } = useParams<{ promoUniqueId: string }>();
  const redirectUserSub: string =
    useAppSelector(
      (state) => state.mailingPreference.promoCodeRedirectUserSub
    );
  const redirectLink: string =
    useAppSelector(
      (state) => state.mailingPreference.promoCodeRedirectLink
    );
  const redirectLinkStatus =
    useAppSelector(
      (state) => state.mailingPreference.promoCodeRedirectLinkStatus
    );
  const userAcc = useAppSelector(state => state.account);
  const isSignedIn = useAppSelector(state => state.account.authState === 'signedin');
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (promoUniqueId) {
      dispatch(setRedirectLink({ redirectLink: 'fetching', redirectUserSub: '' }));
      dispatch(submitCouponRequest("WAPROMO-" + promoUniqueId));
    }
  }, [promoUniqueId]);

  // 01. Auto sign in on non-trivial userSub
  useEffect(() => {
    if (redirectUserSub && (!isSignedIn || userAcc.sub !== redirectUserSub)) {

      // START HOTJAR RECORDING
      (window as any).hj('event', 'start_hotjar_rec');
      (window as any).hj('event', 'event_blasting');
      console.log("START-HOTJAR-REC");
      sendWebsiteLivestreamMessage('[HOTJAR REC - UX] STARTED - REPURCHASE COUPON SCAN');

      dispatch(signIn({ password: '123', useEmail: true, otpValue: '', subTempPass: 'skfajsakjf', userSub: redirectUserSub}));
    }
  }, [redirectUserSub]);

  // 02. We wait until sign in is completed
  if (!isSignedIn || userAcc.sub !== redirectUserSub) {
    return (
      <div style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '500px',
      }}>
        <CircularProgress/>
      </div>
    );
  }

  if (promoUniqueId && redirectLinkStatus === APIRequestStatus.Success && redirectLink) {
    return <Redirect
      to={{
        pathname: redirectLink,
        search: redirectLink?.split('?')?.[1] ? '?' + redirectLink.split('?')[1] : undefined,
      }}
  />;
  } else if (promoUniqueId && redirectLinkStatus === APIRequestStatus.Success) {
    return <Redirect to="/shop" />;
  }

  return <div style={{
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '500px',
  }}>
    <CircularProgress/>
  </div>;
}

export default PageMailingPreference;
